import { JoyStep } from '@templates/Onboarding'

export const ONBOARDING_TITLE = 'Расскажем о действиях с курсом'

export const getOnboardingSteps = (courseId: number): JoyStep[] => [
  {
    target: `#my-course-edit-button-${courseId}`,
    title: 'Редактирование курса',
    content: 'Нажмите, чтобы отредактировать общие параметры курса',
  },
  {
    target: `#my-course-add-section-button-${courseId}`,
    title: 'Создание разделов и тем',
    content:
      'Курс состоит из разделов, разделы состоят из тем. После создания раздела появится возможность добавлять в него темы. Темы можно добавлять в формате PDF или SCORM. SCORM должен быть собран в инструменте iSpring',
  },
  {
    target: `#my-course-add-final-test-button-${courseId}`,
    title: 'Добавление итогового тестирования',
    content:
      'Вы можете добавить итоговое тестирование в курс. Для успешного прохождения курса нужно будет пройти итоговое тестирование на то количество баллов, которое вы укажите. Итоговое тестирование можно заполнить вручную, загрузить из xls или SCORM. Созданное тестирование появится под разделами. Вы сможете его отредактировать или удалить',
  },
  {
    target: `#my-course-publish-button-${courseId}`,
    title: 'Публикация курса',
    content:
      'Когда курс будет готов, опубликуйте его. После этого вы сможете назначать обучения по нему. Вы сможете в любое время снять курс с публикации',
  },
]
